<template>
  <div class="service-speed-container">
    <TitledNumericalInputField
      input-label="Service Speed"
      icon-name="mdi-speedometer"
      :value="+serviceSpeed"
      :on-change="handleServiceSpeedChange"
    />
    <TitledNumericalInputField
      input-label="Speed margin"
      icon-name="mdi-speedometer"
      :value="+speedMargin"
      :on-change="handleSpeedMarginChange"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import TitledNumericalInputField from "../../../../../k_diagram/components/TitledNumericalInputField.vue";
export default {
  name: "SetServiceSpeedComponent",
  components: {
    TitledNumericalInputField,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState("weatherRouting/formModule", ["serviceSpeed", "speedMargin"]),
  },
  methods: {
    handleServiceSpeedChange(value) {
      this.$store.commit("weatherRouting/formModule/SET_SERVICE_SPEED", value, {
        root: true,
      });
    },
    handleSpeedMarginChange(value) {
      this.$store.commit("weatherRouting/formModule/SET_SPEED_MARGIN", value, {
        root: true,
      });
    },
  },
};
</script>

<style scoped>
.service-speed-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 10px;
}
</style>
